import { useCallback, useState } from "react";
import "./card.css";

const Card = ({
  title,
  titleIcon,
  actions,
  children,
  addClasses = "",
  showMaximize = true,
  showHeader = true,
  actionsVisibility = "hover",
}) => {
  const [maximized, setMaximized] = useState(false);
  const [closing, setClosing] = useState(false);
  const [hovered, setHovered] = useState(false);

  const maximizeHandler = useCallback(() => {
    if (maximized) {
      // Play the exit animation while the card is still fixed,
      // then actually restore once it finishes.
      setClosing(true);
      setTimeout(() => {
        setMaximized(false);
        setClosing(false);
      }, 180); // must match the card-maximize-out keyframe duration
    } else {
      setMaximized(true);
    }
  }, [maximized]);

  const showActions =
    actionsVisibility === "always" ||
    (actionsVisibility === "hover" && hovered);
  const hideActions = actionsVisibility === "never";

  return (
    <div
      className={
        (maximized ? "content-wrapper card card-maximized " : "card ") +
        (closing ? "card-closing " : "") +
        addClasses
      }
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {showHeader && (
        <div
          className="card-header"
          style={actionsVisibility === "always" ? { visibility: "visible" } : undefined}
        >
          <h3 className="card-title">
            {titleIcon && <i className={titleIcon}></i>} {title}
          </h3>
          {!hideActions && (
          <div className="card-tools"
              style={{
                visibility: showActions ? "visible" : "hidden",
                pointerEvents: showActions ? "auto" : "none"
              }}
          >
            {actions &&
              actions.map((item) => (
                <button
                  key={`${item.title}_${item.icon}`}
                  type="button"
                  className={`lui-fade-button btn btn-tool ${
                    typeof item.btnClasses === "function"
                      ? item.btnClasses({ maximized })
                      : item.btnClasses
                      ? item.btnClasses
                      : ""
                  }`}
                  title={item.title}
                  onClick={item.action}
                >
                  {/* <span className={item.icon} /> */}
                  {item.icon === "xlsx" ? (
                    <img 
                      src={`${process.env.PUBLIC_URL}/icons/xlsx-file.png`} 
                      alt="XLSX Export Icon" 
                      style={{ width: "24px", height: "24px" }} 
                    />
                  ) : item.icon === "png" ? (
                    <img 
                      src={`${process.env.PUBLIC_URL}/icons/png-file.png`} 
                      alt="PNG Export Icon" 
                      style={{ width: "24px", height: "24px" }} 
                    />
                  ) : item.icon === "pdf" ? (
                    <img 
                      src={`${process.env.PUBLIC_URL}/icons/pdf-file.png`}
                      alt="PDF Export Icon" 
                      style={{ width: "24px", height: "24px" }} 
                    />
                  ) : (
                    <span className={item.icon} />
                  )}
                  {item.title && (
                    <span className="lui-fade-button__text">{item.title}</span>
                  )}
                </button>
              ))}

            {showMaximize && (
              <button
                type="button"
                className="lui-fade-button btn btn-tool"
                onClick={maximizeHandler}
              >
                {maximized ? (
                  <i className="lui-fade-button__icon lui-icon lui-icon--collapse"></i>
                ) : (
                  <i className="lui-fade-button__icon lui-icon lui-icon--expand"></i>
                )}
              </button>
            )}
          </div>
          )}
        </div>
      )}
      <div className="card-body p-1">
        {typeof children === "function"
          ? children({
              maximized,
              // bodyHeight: "100%", //"calc(100vh - 150px)", //"calc(100% - 54px)",
            })
          : children}
      </div>
    </div>
  );
};

export default Card;